module.exports = __webpack_public_path__ + "media/images/city/016-qutb-minar-72c68e4afda824a45f7c416593be686b.svg";